import dayjs from 'dayjs';
import type { CurrencyDisplay } from '@/ccpv2/types/constants';
import { DEFAULT_CURRENCY } from '@/ccpv2/types/constants';
import { formatToCurrency as utilsFormatToCurrency } from '@/ccpv2/utils/currency';
import { formatDateToShortMonthDayYear } from '@/ccpv2/utils/date';
import { toNumberOrNull } from '@/ccpv2/utils/number';

export const formatNumber = (
  value: unknown,
  minimumFractionDigits = 0,
  locale = 'en-US',
  maximumFractionDigits = 20
) => {
  return toNumberOrNull(value)?.toLocaleString(locale, {
    minimumFractionDigits,
    maximumFractionDigits,
  });
};

export const formatToCurrency = (
  value: unknown,
  currency: string | null | undefined = 'USD',
  precision: number | null | undefined = 0,
  display: CurrencyDisplay | undefined = 'code'
) => {
  return utilsFormatToCurrency(toNumberOrNull(value), currency || DEFAULT_CURRENCY, precision, display);
};

export const formatToPercentage = (value: unknown, precision = 0) => {
  if (toNumberOrNull(value) === null) return '';

  return (Number(value) * 100).toFixed(precision) + '%';
};

export const formatDate = (isoDateStr: unknown, formatOptions?: string) => {
  if (typeof isoDateStr !== 'string') return '';

  const res = formatOptions ? dayjs(isoDateStr).format(formatOptions) : formatDateToShortMonthDayYear(isoDateStr);

  return res === 'Invalid Date' ? '' : res;
};
